import AxiosConfig from '../utils/AxiosConfig';

class LearningService {
  async getCourses() {
    const response = await AxiosConfig.get('/learning/courses');
    return response.data?.data || response.data || [];
  }

  async getGuideAssets(guideId) {
    const response = await AxiosConfig.get(`/learning/guides/${guideId}/assets`);
    return response.data?.data || response.data;
  }
}

export default new LearningService();
